export const getProcessParticipantPartialValidationSchema = () => {
    const objValidation: Record<string, any> = {};
    return objValidation;
};

export const getProcessParticipantFormLabels = () => ({});
